import { Directive, ElementRef, HostListener, Input, OnInit, inject } from '@angular/core';

export type AspectProperty = 'width' | 'height';

@Directive({
  standalone: true,
  selector: '[nrcAspectRatio]'
})
export class AspectRatioDirective implements OnInit {
  private readonly el = inject(ElementRef);

  // Input to distinguish, if width or height should be used. Defaults to width.
  @Input() public nrcAspectRatioBasedOn: AspectProperty = 'width';

  /**
   *
   */
  public ngOnInit(): void {
    this.resize();
  }

  /**
   *
   */
  @HostListener('window:resize')
  public onChange(): void {
    this.resize();
  }

  /**
   * Resizes the element to maintain a 1:1 aspect ratio based on the specified dimension.
   */
  private resize(): void {
    // Set the dimension based on the input property.
    if (this.nrcAspectRatioBasedOn === 'width') {
      this.el.nativeElement.style.height = `${this.el.nativeElement.offsetWidth}px`;
    } else {
      this.el.nativeElement.style.width = `${this.el.nativeElement.offsetHeight}px`;
    }
  }
}
